import { render } from "./FormSearchItemSales.vue?vue&type=template&id=c23040fa&scoped=true"
import script from "./FormSearchItemSales.vue?vue&type=script&lang=js"
export * from "./FormSearchItemSales.vue?vue&type=script&lang=js"

import "./FormSearchItemSales.vue?vue&type=style&index=0&id=c23040fa&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c23040fa"]])

export default __exports__